<template>
    <div>
       <el-form :inline="true">
           <el-form-item><el-input placeholder="请输入币种" v-model="coinType"></el-input></el-form-item>
           <el-form-item><el-button type="primary" @click="queryList(1)">搜索</el-button></el-form-item>
           <el-form-item><el-button type="primary" @click="openBox">新增</el-button></el-form-item>
           <el-form-item label="使用说明:">
               <span>配置的币种需要进行入账人工审核。1.逐条审核打开：所有的入账订单都需要审核；2.数量阀值：审核开关关闭，该笔订单充值数量大于该阀值则进入审核，默认为0；3.当逐条审核关闭，数量阀值设置为0，当订单币种价值＞配置的价值阀值时，订单进入人工审核，价值阀值=单笔充值数量*当前价格</span>
           </el-form-item>
       </el-form>

        <el-table :data="configInfo">
            <el-table-column label="币种" prop="coinType"></el-table-column>
            <el-table-column label="逐条审核">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.auditSwitch" active-color="#13ce66" inactive-color="#ff4949" disabled></el-switch>
                </template>
            </el-table-column>
            <el-table-column label="数量阈值" prop="thresholdNum"></el-table-column>
            <el-table-column label="价值阈值(单位:$)" prop="thresholdPrice"></el-table-column>
            <el-table-column>
                <template slot-scope="scope">
                    <el-button type="text" @click="onEdit(scope.row)">编辑</el-button>
                    <el-button type="danger" @click="onRemove(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination background layout="prev, pager, next" :total="configTotal" :page-size="25" :current-page="pageNo" @current-change="queryList"></el-pagination>

        <el-dialog title="配置详情" :visible.sync="showEdit" @close="closeEdit()">
            <el-form :model="config" ref="editForm" label-width="150px">
                <el-form-item label="币种" prop="coinType" :rules="[{ required: true, message: '币种不能为空',trigger: 'blur'}]">
                    <el-input v-model="config.coinType"></el-input>
                </el-form-item>
                <el-form-item label="逐条审核" prop="auditSwitch" :rules="[{ required: true, message: '币种不能为空',trigger: 'blur'}]">
                    <el-switch v-model="config.auditSwitch" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
                </el-form-item>
                <el-form-item label="数量阈值" prop="thresholdNum" :rules="[{ required: true, message: '数量阈值不能为空',trigger: 'blur'}]">
                    <el-input v-model="config.thresholdNum"></el-input>
                </el-form-item>
                <el-form-item label="价值阈值(单位:$)" prop="thresholdPrice" :rules="[{ required: true, message: '价值阈值不能为空',trigger: 'blur'}]">
                    <el-input v-model="config.thresholdPrice"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="info" @click="closeEdit()">取消</el-button>
                    <el-button type="primary" @click="submitInfo()">提交</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    import api from './api';
    export default {
        name: "manualAuditConfig",
        data(){
            return {
                configInfo:[],
                configTotal: 0,
                showEdit: false,
                pageNo: 1,
                opType: '',
                coinType: '',
                config: {
                    coinType: '',
                    auditSwitch: true,
                    thresholdNum: 0,
                    thresholdPrice: 0
                }
            }
        },
        created() {
            this.queryList(1);
        },
        methods:{
            queryList(val) {
                this.pageNo = val;
                api.configList({coinType:this.coinType,page:this.pageNo}).then(response =>{
                    this.configInfo = response.data.list;
                    this.configTotal = response.data.totalCount;
                })
            },
            openBox() {
                this.showEdit = true
                this.config = {
                    coinType: '',
                    auditSwitch: true,
                    thresholdNum: 0,
                    thresholdPrice: 0
                }
            },
            closeEdit() {
                this.$refs['editForm'].resetFields();
                this.opType = '';
                this.showEdit = false;
            },
            onEdit(info) {
                this.config = JSON.parse(JSON.stringify(info));
                this.opType = 'update';
                this.showEdit = true;
            },
            onRemove(info) {
                this.$confirm('确认删除吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    api.configRemove(info).then(() =>{
                                this.$message.success('删除成功');
                                this.queryList(1);
                            })
                });
            },
            submitInfo(){
                this.$refs['editForm'].validate( valid => {
                    if (valid) {
                        if (this.opType === 'update'){
                            api.configUpdate(this.config).then(() =>{
                                this.$message.success('修改成功');
                                this.queryList(1);
                                this.closeEdit();
                            })
                        }else {
                            api.configInsert(this.config).then(() =>{
                                this.$message.success('新增成功');
                                this.queryList(1);
                                this.closeEdit();
                            })
                        }
                    }
                })
            },
        }
    }
</script>

<style scoped>

</style>
